/** postMessage contract for admin → client live mobility preview. */

export const MOBILITY_PREVIEW_MESSAGE_TYPE = 'MOBILITY_PREVIEW';
export const MOBILITY_PREVIEW_VERSION = 1;

const MAX_KEY_LENGTH = 64;
const MAX_LABEL_LENGTH = 255;
const MAX_ICON_LENGTH = 64;

export function getAllowedAdminOrigin() {
  return (process.env.REACT_APP_ADMIN_ORIGIN || 'http://localhost:5173')
    .trim()
    .replace(/\/$/, '');
}

if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_ADMIN_ORIGIN) {
  // eslint-disable-next-line no-console
  console.warn(
    '[Mobility] REACT_APP_ADMIN_ORIGIN is not set. ' +
    'Live preview postMessage validation will use the localhost default.'
  );
}

function isSafePreviewButton(button) {
  if (!button || typeof button !== 'object') return false;
  if (typeof button.key !== 'string' || !button.key.trim()) return false;
  if (button.key.length > MAX_KEY_LENGTH) return false;
  if (button.label != null) {
    if (typeof button.label !== 'string' || button.label.length > MAX_LABEL_LENGTH) return false;
  }
  if (button.icon != null) {
    if (typeof button.icon !== 'string' || button.icon.length > MAX_ICON_LENGTH) return false;
  }
  if (button.url != null && typeof button.url !== 'string') return false;
  return true;
}

/**
 * Validates the postMessage envelope before applying preview config.
 * URL protocol checks remain in resolveMobilityConfig / openExternalUrl.
 */
export function isValidPreviewMessage(data) {
  if (!data || typeof data !== 'object') return false;
  if (data.type !== MOBILITY_PREVIEW_MESSAGE_TYPE) return false;
  if (data.version !== MOBILITY_PREVIEW_VERSION) return false;
  if (!data.config || typeof data.config !== 'object') return false;
  if (!Array.isArray(data.config.buttons)) return false;
  return data.config.buttons.every(isSafePreviewButton);
}

export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
